import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withNamespaces} from 'react-i18next';

import AgentInboxListing from "./AgentInboxListing";
import AgentInboxCreate from "./AgentInboxCreate";
import AgentInboxShow from "./AgentInboxShow";
import Button from "../../components/Button/Button";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { filterErrorHandler } from '../../hoc/Shared/utility';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSearch} from '@fortawesome/free-solid-svg-icons'

import { dropdownAgentInbox, getAgentInbox } from "../../store/ducks/agentInbox/actions";

const initialFilteringState = {
    title: "",
    category: ""
};

class Inbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            pageShow: "listing",
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: '',
            totalRecords: 0,
            searchValue: '',
            data: [],
            dropdownCategory: [],
            filterInput: initialFilteringState,
            detailsParam: {},
            permission: []
        }
    }

    componentDidMount() {
        const data = this.fetchData();
        this.props.getAgentInbox(data);

        const dropdownArr = {};
        this.props.dropdownAgentInbox(dropdownArr);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(nextState.permission.length === 0 && this.props.currentPermission!==undefined){
            this.setState({ permission: this.props.currentPermission });
        }

        if(nextProps.agent_inbox_data !== undefined && nextProps.agent_inbox_data !== this.props.agent_inbox_data){
            if(nextProps.agent_inbox_data.data.responseCode === 200 && nextProps.agent_inbox_data.data.msgType === "success"){
                this.setState({
                    loading: false,
                    data: nextProps.agent_inbox_data.data.data.result.row,
                    totalRecords: nextProps.agent_inbox_data.data.data.result.pagination.total_record
                });
            }
            else{
                this.setState({
                    data: [],
                    totalRecords: 0,
                    activePage: 1,
                    loading: false
                }, () => {
                    filterErrorHandler(nextProps.agent_inbox_data.data.message);
                });
            }
        }

        if(nextProps.dropdown_agent_inbox !== undefined && nextProps.dropdown_agent_inbox !== this.props.dropdown_agent_inbox){
            if(nextProps.dropdown_agent_inbox.data.responseCode === 200 && nextProps.dropdown_agent_inbox.data.msgType === "success"){
                this.setState({
                    loading: false,
                    dropdownCategory: nextProps.dropdown_agent_inbox.data.data.category
                });
            }
            else{
                this.setState({
                    loading: false,
                    dropdownCategory: []
                }, () => {
                    filterErrorHandler(nextProps.dropdown_agent_inbox.data.message);
                });
            }
        }

        return true;
    }

    fetchData = () => {
        const listingArr = {};
        let availablePage = this.state.activePage;
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            (this.state.activePage >= availablePage) && this.setState({ activePage: availablePage});
        }
        listingArr.page = (this.state.activePage >= availablePage) ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);
        Object.keys(this.state.filterInput).forEach((val) => {
            // listingArr[val] = ((val==='start_date' || val==='end_date') && this.state.filterInput[val]!=='') ? moment(this.state.filterInput[val]).format("YYYY-MM-DD") : this.state.filterInput[val];
            listingArr[val] = this.state.filterInput[val];
        });

        return listingArr;
    }

    onInputChange(event) {
        let newFilter = Object.assign({}, this.state.filterInput);
        if(event.target.id==='transaction_date'){
            const date = (event.target.value!=='') ? event.target.value.split(" - ") : null;
            newFilter['start_date'] = (date) ? date[0] : '';
            newFilter['end_date'] = (date) ? date[1] : '';
            newFilter['date'] = event.target.value;
        }
        else{
            newFilter[event.target.id] = event.target.value;
        }

        this.setState({
            filterInput: newFilter
        });
    }

    clearHandler = () => {
        let newFilter = initialFilteringState;
        this.setState({
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            searchValue: '',
            order: '',
            filterInput: newFilter,
            loading: true,
            data: [],
        }, () => {
            const listingArr = this.fetchData();
            this.props.getAgentInbox(listingArr);
        });
    }

    refreshHandler = () => {
        this.setState({
            loading: true,
            data: [],
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            order: '',
        }, () => {
            const listingArr = this.fetchData();
            this.props.getAgentInbox(listingArr);
        });
    }

    // go to details
    detailsHandler = (e, id) => {
        e.preventDefault();
        this.setState({
            pageShow: 'details',
            detailsParam : {
                id: id
            }
        });
    }

    changePageHandler = (page) => {
        this.setState({
            pageShow: page,
        });
    }

    datatablesChangeHandler = (val, act) => {
        this.setState({
            [act]: (act==='searchValue') ? val.target.value : val,
            loading: true,
            data: [],
        }, () => {
            const listingArr = this.fetchData();
            this.props.getAgentInbox(listingArr);
        });
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = (order === "asc") ? true : false ;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({
            order: orderArry,
            loading: true,
            data: [],
        }, () => {
            const listingArr = this.fetchData();
            this.props.getAgentInbox(listingArr);
        });
    }

    noFormatter = (cell, row, rowIndex) => {
        let rowNumber = (this.state.activePage - 1) * this.state.limit + (rowIndex + 1);
        return <span>{rowNumber}</span>;
    };

    actionFormatter = (cell, row) => {
        let editButton, output;

        if (this.state.permission.includes("agent_inbox_view")) {
            editButton = (
                <Button
                    typeButton="button"
                    classValue="btn btn-sm btn-white"
                    key={`edit-${row.id}`}
                    idValue={row.id === undefined ? 0 : row.id}
                    clicked={(event) => this.detailsHandler(event, row.id)}
                    buttonName={<FontAwesomeIcon icon={faSearch} />}
                />
            );
        }

        output = [editButton];
        return output;
    }

    render() {
        const { t } = this.props;

        const columns = [
            { text: t("global.no"), dataField: "no", formatter: this.noFormatter, headerStyle: { width: "60px" } },
            { text: t("agent-inbox.title"), dataField: "title", sort: true, onSort: this.onSort },
            { text: t("agent-inbox.category"), dataField: "category", sort: true, onSort: this.onSort },
            { text: t("global.action"), dataField: "#", formatter: this.actionFormatter, headerStyle: { width: "65px" } },
        ];

        let dataListing = this.state.data.map((val, idx) => {
            return {
                id: val.id,
                title: val.title,
                category: val.category
            }
        });

        return (
            <Auxiliary>
                {this.state.pageShow === 'listing' && (
                    <AgentInboxListing
                        changePageHandler={(page) => this.changePageHandler(page)}
                        datatablesChangeHandler={(val, act) => this.datatablesChangeHandler(val, act)}
                        onInputChange={(event) => this.onInputChange(event)}
                        clearHandler={() => this.clearHandler()}
                        refreshHandler={() => this.refreshHandler()}
                        filterInput={this.state.filterInput}
                        ddCategory={this.state.dropdownCategory}
                        columns={columns}
                        dataListing={dataListing}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        loading={this.state.loading}
                        permission={this.state.permission}
                    />
                )}

                {this.state.permission.includes("agent_inbox_create") && this.state.pageShow === 'create' && (
                    <AgentInboxCreate 
                        changePageHandler={(page) => this.changePageHandler(page)}
                        refreshHandler={() => this.refreshHandler()}
                    />
                )}

                {this.state.permission.includes("agent_inbox_view") && this.state.pageShow === 'details' && (
                    <AgentInboxShow 
                        detailsParam={this.state.detailsParam}
                        changePageHandler={(page) => this.changePageHandler(page)}
                    />
                )}
            </Auxiliary>
        )
    }
};

//Received the response from the redux calling the api response
const mapStateToProps = state => {
    return {
        currentPermission: state.currentUser.data.permission,
        agent_inbox_data: state.agentInbox.agent_inbox_data,
        dropdown_agent_inbox: state.agentInbox.dropdown_agent_inbox
    }
};

const mapDispatchToProps = {
    getAgentInbox,
    dropdownAgentInbox
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces('translation')(Inbox));